import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import * as Constants from "../../../Helper/constants/constants";
import Loader from "../../../Helper/loader";
import WithoutImageHeader from "../../../Helper/withoutImageHeader";
import NoDataComponent from "../../CommanComponents/NoDataComponent";
import AdminDashbordFunctons from "./functions";
function Dashboard() {
    const {
        wardList,
        getWardsList,
        getHospitalList,
        hospitalList,
        dropdownValue,
        setDropdownValue,
        navigate,
        hospitalId,
        setHospitalId,
        loader,
        setLoader,
        breadcrumData,
        breadcrumItem
    } = AdminDashbordFunctons();

    useEffect(() => {
        getWardsList();
        getHospitalList();
    }, []);


    useEffect(() => {
        getWardsList();
    }, [hospitalId]);



    return (
        <div className="main_dashboard_screen">
            {
                <WithoutImageHeader
                    header={Constants.DASHBOARD}
                    breadcrumData={breadcrumData}
                    breadcrumItem={breadcrumItem}
                    // hospitalList={hospitalList}
                    // setDropdownValue={setDropdownValue}
                    // dropdownValue={dropdownValue}
                    // setHospitalId={setHospitalId}
                    lefticon='menu'
                />
            }
            {/* <DrawerComponent /> */}
            <Container>
                {/* {<DashboardHeader/>} */}
                <div className="dashboard_area">
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <div className="inner_dashboard_area">
                                <div className="ward_view_page">
                                    <div className="inner_ward">
                                        <div className="top_head">
                                            <h4>Ward</h4>
                                        </div>
                                        <div className="ward_listing">
                                            {loader ? <Loader
                                                loader={loader}
                                            /> : <Row>
                                                {
                                                    !loader && wardList.length > 0 ?
                                                        wardList.map((item, i) => {
                                                            return (
                                                                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12} key={i}>
                                                                    <div className="list_view"
                                                                    // onClick={() => navigate('/patient-list', { state: { name: item.title } })}
                                                                    >
                                                                        <p>{item.title}</p>
                                                                    </div>
                                                                </Col>
                                                            )
                                                        })
                                                        :
                                                        <NoDataComponent
                                                            message={'No wards found'}
                                                        />
                                                }
                                            </Row>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
}

export default Dashboard;